import React from "react";
import TopBar from "../../components/TopBar";
import visa from "../../assets/visa.png";
import master from "../../assets/master.png";
import paystack from "../../assets/Paystack_Logo.png";
import discover from "../../assets/discover.png";
import paypal from "../../assets/paypal.png";
import maestro from "../../assets/maestro.png";
import Button from "../../components/Button/Button";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Paystack from "../../components/Payment/Paystack";
import Loading from "../../components/Loading";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { bookAppointmentAction } from "../../redux/actions/appointmentActions";
import { resetPayment } from "../../redux/actions/payment";
import swal from "sweetalert";
import { formatter } from "../../utils";
import { FaCreditCard, FaShieldAlt, FaLock, FaCheckCircle, FaMoneyBillWave } from "react-icons/fa";

export default function Payment() {
    const paymentData = useSelector((state) => state.createPayment);
    let loading = paymentData.loading;
    const appt = useSelector((state) => state.bookAppontment);
    const navigate = useNavigate();
    const data = useLocation().state.data;
    const dispatch = useDispatch();

    const user = JSON.parse(localStorage.getItem("userInfo"));
    console.log("data user", user);
    console.log("data pay", data);
    console.log("data paymentData", paymentData);

    React.useEffect(() => {
        if (paymentData.error || appt.error) {
            toast.error(paymentData.error || appt.error);
        }
        if (paymentData.success) {
            toast.success('Appointment booked successfully', {
                autoClose: 1000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            
            // Reset payment state before navigation to prevent auto-navigation on next visit
            dispatch(resetPayment());
            dispatch({ type: "BOOK_APPOINTMENT_RESET" });
            
            navigate('/appointment-booked', { state: { data: data } });
        }
    }, [paymentData.success, paymentData.error, appt.error, appt.success, dispatch, navigate, data])

    // Cleanup effect to reset payment state when component unmounts
    React.useEffect(() => {
        return () => {
            dispatch(resetPayment());
            dispatch({ type: "BOOK_APPOINTMENT_RESET" });
        };
    }, [dispatch])

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
            <TopBar title={"Payment"} url={'/appointment-online'} />
            
            <div className="flex flex-col items-center justify-center px-4 py-6 sm:px-6 lg:px-8">
                <div className="w-full max-w-md mx-auto">
                    
                    {/* Payment Amount Card */}
                    <div className="bg-gradient-to-r from-primary100 to-blue-600 rounded-3xl shadow-2xl text-white mb-8 overflow-hidden">
                        <div className="relative p-8">
                            {/* Decorative Elements */}
                            <div className="absolute top-4 right-4 opacity-20">
                                <FaMoneyBillWave className="text-4xl" />
                            </div>
                            
                            {/* Amount Header */}
                            <div className="text-center mb-6">
                                <div className="flex items-center justify-center mb-4">
                                    <div className="h-0.5 w-8 bg-white bg-opacity-60 mr-3"></div>
                                    <h2 className="text-xl font-semibold">Payment Amount</h2>
                                    <div className="h-0.5 w-8 bg-white bg-opacity-60 ml-3"></div>
                                </div>
                                
                                {/* Amount Display */}
                                <div className="relative">
                                    <h1 className="text-5xl sm:text-6xl font-bold mb-2">
                                        &#8358;{formatter.format(data?.amount)}
                                    </h1>
                                    <p className="text-white text-opacity-80 text-sm">
                                        Appointment Fee
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Security Features */}
                    <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
                        <div className="flex items-center justify-center mb-4">
                            <FaShieldAlt className="text-green-500 text-2xl mr-3" />
                            <h3 className="text-lg font-semibold text-gray-800">Secure Payment</h3>
                        </div>
                        <div className="grid grid-cols-2 gap-4 text-center">
                            <div className="flex flex-col items-center">
                                <FaLock className="text-primary100 text-xl mb-2" />
                                <span className="text-sm text-gray-600">SSL Encrypted</span>
                            </div>
                            <div className="flex flex-col items-center">
                                <FaCheckCircle className="text-green-500 text-xl mb-2" />
                                <span className="text-sm text-gray-600">Verified</span>
                            </div>
                        </div>
                    </div>

                    {/* Payment Methods */}
                    <div className="bg-white rounded-2xl shadow-lg p-6 mb-6">
                        <div className="flex items-center justify-center mb-6">
                            <FaCreditCard className="text-primary100 text-xl mr-3" />
                            <h3 className="text-lg font-semibold text-gray-800">Accepted Payment Methods</h3>
                        </div>
                        
                        <div className="grid grid-cols-3 gap-4">
                            <div className="bg-gray-50 rounded-xl p-4 border-2 border-transparent hover:border-primary100 transition-all duration-300 transform hover:scale-105">
                                <img src={visa} alt="Visa" className="w-full h-8 object-contain" />
                            </div>
                            <div className="bg-gray-50 rounded-xl p-4 border-2 border-transparent hover:border-primary100 transition-all duration-300 transform hover:scale-105">
                                <img src={paystack} alt="Paystack" className="w-full h-8 object-contain" />
                            </div>
                            <div className="bg-gray-50 rounded-xl p-4 border-2 border-transparent hover:border-primary100 transition-all duration-300 transform hover:scale-105">
                                <img src={master} alt="Mastercard" className="w-full h-8 object-contain" />
                            </div>
                        </div>
                        
                        {/* Additional Payment Options */}
                        <div className="grid grid-cols-3 gap-4 mt-4">
                            <div className="bg-gray-50 rounded-xl p-4 border-2 border-transparent hover:border-primary100 transition-all duration-300 transform hover:scale-105">
                                <img src={discover} alt="Discover" className="w-full h-8 object-contain" />
                            </div>
                            <div className="bg-gray-50 rounded-xl p-4 border-2 border-transparent hover:border-primary100 transition-all duration-300 transform hover:scale-105">
                                <img src={paypal} alt="PayPal" className="w-full h-8 object-contain" />
                            </div>
                            <div className="bg-gray-50 rounded-xl p-4 border-2 border-transparent hover:border-primary100 transition-all duration-300 transform hover:scale-105">
                                <img src={maestro} alt="Maestro" className="w-full h-8 object-contain" />
                            </div>
                        </div>
                    </div>

                    {/* Payment Action */}
                    <div className="bg-white rounded-2xl shadow-lg p-6">
                        <div className="text-center mb-4">
                            <h3 className="text-lg font-semibold text-gray-800 mb-2">Complete Your Payment</h3>
                            <p className="text-gray-600 text-sm">
                                Secure checkout powered by Paystack
                            </p>
                        </div>
                        
                        {loading || appt.loading ? (
                            <div className="flex flex-col items-center py-8">
                                <Loading />
                                <p className="text-gray-600 mt-4">Processing payment...</p>
                            </div>
                        ) : (
                            <div className="space-y-4">
                                <Paystack 
                                    amount={data.amount} 
                                    email={user.email.trim()} 
                                    phone={user.mobile} 
                                    notes={"Payment for Online Appointment"} 
                                    url={"appointment-booked"} 
                                    compData={data}
                                    paymentType="appointment"
                                    buttonText="Complete Payment"
                                    onPaymentSuccess={(reference, appointmentData) => {
                                        console.log('Payment successful for appointment:', reference, appointmentData);
                                    }}
                                    onPaymentError={(error) => {
                                        console.error('Payment failed:', error);
                                    }}
                                />
                                
                                {/* Terms and Conditions */}
                                <div className="text-center">
                                    <p className="text-xs text-gray-500">
                                        By proceeding, you agree to our{" "}
                                        <span className="text-primary100 underline cursor-pointer">
                                            Terms of Service
                                        </span>{" "}
                                        and{" "}
                                        <span className="text-primary100 underline cursor-pointer">
                                            Privacy Policy
                                        </span>
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Support Information */}
                    <div className="text-center mt-6">
                        <p className="text-gray-500 text-sm">
                            Need help? Contact our{" "}
                            <span className="text-primary100 font-medium cursor-pointer">
                                support team
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
